<template>
  <IQOS :systemDependency="mode" :title="$t('system_motd.title')" required>
    <p class="iqos-comment bold qrw-paragraph-md mt-16">
      {{ mode == 'inside' ? $t("system_motd.popup_title") : $t("system_motd.btn_title") }}
    </p>
    <BaseInput
      v-model="ui_button_title"
      class="mt-8 w-100"
      @blur="save"
      fullWidth
      :placeholder="mode.toUpperCase()"
      :readonly="false"
    />

    <p
      class="iqos-comment bold qrw-paragraph-md mt-16"
    >
      {{ $t("system_motd.motd_title") }}
    </p>

    <BaseTextarea
      class="mt-8"
      :placeholder="$t('system_motd.ph')"
      :readonly="false"
      :rows="6"
      v-model="motd"
      @blur="save"
    />

    <p class="iqos-comment qrw-paragraph-md mt-16">
      {{
        $t("system_motd.desc_1", {
          mode: mode == 'preorder' ? 'TAKEAWAY' : mode.toUpperCase(),
        })
      }}
    </p>

    <p class="iqos-comment qrw-paragraph-md mt-16">
      {{ $t("system_motd.desc_2") }}
    </p>
  </IQOS>
</template>

<script>
import IQOS from "@/components/IQOS.vue";
import BlackTextarea from "@/components/BlackTextarea.vue";
import BlackInput from "@/components/BlackInput.vue";

export default {
  components: {
    IQOS,
    BlackTextarea,
    BlackInput,
  },
  props: {
    mode: String,
  },
  data() {
    return {
      motd: null,
      ui_button_title: null,
    };
  },
  mounted() {
    const cafe = this.$store.state.cafe;
    const container = this.mode == "inside" ? cafe : cafe[this.mode];
    this.motd = container.motd || null;

    // if (this.mode != "inside")
      this.ui_button_title =
        container.ui_button_title || this.mode.toUpperCase();
  },
  methods: {
    save() {
      this.$store.commit("setModeMotd", {
        mode: this.mode,
        value: this.motd ? this.motd.trim() : null,
      });
      
      this.$store.commit("setModeButtonTitle", {
        mode: this.mode,
        value: this.ui_button_title ? this.ui_button_title.trim() : null,
      });
      this.$store.dispatch("saveCafe");

      this.$store.dispatch("auditlog/write", {
        type: "change_mode_motd",
        payload: {
          mode: this.mode,
          value: this.motd || '-',
        },
      });
    },
  },
};
</script>

<style>
</style>